import { useState } from 'preact/hooks'

export const useRefetch = () => {
  const [refetch, setRefetch] = useState(0)
  const handleRefetch = () => setRefetch((n) => (n += 1))

  return { refetch, handleRefetch }
}
